import React from "react";

import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Image
} from "@react-pdf/renderer";


/*
====================================================
LOCAL SCHOOL LOGO
====================================================
*/

import schoolLogo from "./savationChristLogo.png";



/*
====================================================
COLORS
====================================================
*/

const COLORS = {

    navy:
        "#0F172A",

    blue:
        "#2563EB",

    sky:
        "#E0F2FE",

    gold:
        "#D97706",

    green:
        "#059669",

    red:
        "#DC2626",

    text:
        "#1F2937",

    gray:
        "#6B7280",

    border:
        "#CBD5E1",

    white:
        "#FFFFFF",

    light:
        "#F8FAFC"

};





/*
====================================================
STYLES
====================================================
*/

const styles = StyleSheet.create({


    page: {

        paddingTop:
            22,

        paddingBottom:
            35,

        paddingHorizontal:
            25,

        fontSize:
            9,

        fontFamily:
            "Helvetica",

        color:
            COLORS.text

    },



/*
====================================================
UNIVERSITY HEADER
====================================================
*/


    header: {

        flexDirection:
            "row",

        alignItems:
            "center",

        borderBottomWidth:
            2,

        borderBottomColor:
            COLORS.blue,

        paddingBottom:
            10,

        marginBottom:
            12

    },



    logo: {

        width:
            65,

        height:
            65,

        marginRight:
            15

    },



    headerContent: {

        flex:
            1

    },



    schoolTitle: {

        fontSize:
            18,

        fontWeight:
            "bold",

        color:
            COLORS.navy

    },



    documentTitle: {

        fontSize:
            12,

        marginTop:
            4,

        fontWeight:
            "bold",

        color:
            COLORS.blue

    },



    headerSubtitle: {

        marginTop:
            4,

        fontSize:
            8,

        color:
            COLORS.gray

    },





/*
====================================================
SCHOOL INFORMATION
====================================================
*/


    schoolSection: {

        backgroundColor:
            COLORS.light,

        borderWidth:
            1,

        borderColor:
            COLORS.border,

        padding:
            8,

        marginBottom:
            10

    },



    schoolName: {

        fontSize:
            12,

        fontWeight:
            "bold",

        color:
            COLORS.navy

    },



    normalText: {

        fontSize:
            8,

        marginTop:
            3

    },







/*
====================================================
STUDENT PROFILE
====================================================
*/


    studentBox: {

        flexDirection:
            "row",

        borderWidth:
            1,

        borderColor:
            COLORS.border,

        padding:
            8,

        marginBottom:
            10

    },



    studentImage: {

        width:
            65,

        height:
            65,

        marginRight:
            12

    },



    imagePlaceholder: {

        width:
            65,

        height:
            65,

        backgroundColor:
            COLORS.sky,

        justifyContent:
            "center",

        alignItems:
            "center",

        marginRight:
            12

    },



    placeholderText: {

        fontSize:
            20,

        color:
            COLORS.blue

    },



    studentDetails: {

        flex:
            1

    },



    studentName: {

        fontSize:
            14,

        fontWeight:
            "bold",

        color:
            COLORS.navy,

        marginBottom:
            5

    },



    infoRow: {

        flexDirection:
            "row",

        marginBottom:
            3

    },


    label: {

        width:
            100,

        color:
            COLORS.gray

    },


    value: {

        fontWeight:
            "bold",

        color:
            COLORS.text

    },







/*
====================================================
ACCOUNT SUMMARY
====================================================
*/


    summaryBox: {

        borderWidth:
            1,

        borderColor:
            COLORS.border,

        padding:
            8,

        marginBottom:
            10

    },


    sectionTitle: {

        fontSize:
            11,

        fontWeight:
            "bold",

        color:
            COLORS.blue,

        marginBottom:
            6

    },


});





/*
====================================================
HELPERS
====================================================
*/


const formatMoney = (
    amount
) => {

    return Number(
        amount || 0
    )
    .toLocaleString(
        undefined,
        {
            minimumFractionDigits:
                2
        }
    );

};




const formatDate = (
    date
) => {

    if(
        !date
    ){

        return "-";

    }


    return new Date(
        date
    )
    .toLocaleDateString();

};






/*
====================================================
DOCUMENT COMPONENT
====================================================
*/


const StudentPaymentHistoryPDF = ({

    student,

    transactions,

    academicYear

}) => {



    const totalPaid =

        transactions.reduce(

            (
                total,

                item

            ) =>

                total +
                Number(
                    item.amount_paid || 0
                ),

            0

        );




    const totalBalance =

        transactions.reduce(

            (
                total,

                item

            ) =>

                total +
                Number(
                    item.balance || 0
                ),

            0

        );





return (


<Document>


<Page

    size="A4"

    wrap={false}

    style={
        styles.page
    }

>



{/* ============================================
    UNIVERSITY STYLE HEADER
============================================ */}



<View

style={
    styles.header
}

>


<Image

    src={
        schoolLogo
    }

    style={
        styles.logo
    }

/>



<View

style={
    styles.headerContent
}

>


<Text

style={
    styles.schoolTitle
}

>

Salvation In Christ School System - SICSS

</Text>



<Text

style={
    styles.documentTitle
}

>

STUDENT PAYMENT STATEMENT

</Text>



<Text

style={
    styles.headerSubtitle
}

>

Official Student Financial Record | Finance Department

</Text>



</View>


</View>






{/* ============================================
    SCHOOL INFORMATION
============================================ */}



<View

style={
    styles.schoolSection
}

>


<Text

style={
    styles.schoolName
}

>

Finance & Student Accounts Office

</Text>



<Text

style={
    styles.normalText
}

>

Academic Year:

{" "}

{
    academicYear?.name ||
    "-"
}

</Text>



<Text

style={
    styles.normalText
}

>

Generated Date:

{" "}

{
    new Date()
    .toLocaleDateString()
}

</Text>


</View>







{/* ============================================
    STUDENT PROFILE
============================================ */}



<View

style={
    styles.studentBox
}

>


{

student?.student_image ?


<Image

src={
    student.student_image
}

style={
    styles.studentImage
}

/>


:


<View

style={
    styles.imagePlaceholder
}

>

<Text

style={
    styles.placeholderText
}

>

?

</Text>

</View>


}



<View

style={
    styles.studentDetails
}

>


<Text

style={
    styles.studentName
}

>

{
    student?.full_name ||
    "Student Name"
}

</Text>



<View

style={
    styles.infoRow
}

>

<Text

style={
    styles.label
}

>

Admission No:

</Text>


<Text

style={
    styles.value
}

>

{
    student?.id ||
    "-"
}

</Text>


</View>




<View

style={
    styles.infoRow
}

>

<Text

style={
    styles.label
}

>

Grade Class:

</Text>


<Text

style={
    styles.value
}

>

{
student?.grade_class_name ||
"-"
}

</Text>


</View>





<View

style={
    styles.infoRow
}

>

<Text

style={
    styles.label
}

>

Academic Year:

</Text>


<Text

style={
    styles.value
}

>

{
academicYear?.name ||
"-"
}

</Text>


</View>




</View>



</View>







{/* ============================================
    ACCOUNT SUMMARY
============================================ */}



<View

style={
    styles.summaryBox
}

>


<Text

style={
    styles.sectionTitle
}

>

Account Summary

</Text>



<View

style={
    styles.infoRow
}

>

<Text

style={
    styles.label
}

>

Total Transactions:

</Text>


<Text

style={
    styles.value
}

>

{
    transactions.length
}

</Text>


</View>





<View

style={
    styles.infoRow
}

>

<Text

style={
    styles.label
}

>

Total Paid:

</Text>


<Text

style={{
fontWeight:
"bold",
color:
COLORS.green
}}

>

$

{
formatMoney(
totalPaid
)
}

</Text>


</View>





<View

style={
    styles.infoRow
}

>

<Text

style={
    styles.label
}

>

Outstanding Balance:

</Text>


<Text

style={{
fontWeight:
"bold",
color:
COLORS.red
}}

>

$

{
formatMoney(
totalBalance
)
}

</Text>


</View>



</View>
// ====================================================
// PAYMENT TRANSACTION LEDGER
// ====================================================


<View

    style={{

        marginTop:
            5

    }}

>


<Text

    style={{

        fontSize:
            11,

        fontWeight:
            "bold",

        color:
            COLORS.blue,

        marginBottom:
            6

    }}

>

Payment Transaction Ledger

</Text>



</View>





{/* ====================================================
    TABLE HEADER
==================================================== */}



<View

    fixed

    style={{

        flexDirection:
            "row",

        backgroundColor:
            COLORS.navy,

        paddingVertical:
            5,

        paddingHorizontal:
            4

    }}

>



<Text
style={{

    width:
        "5%",

    color:
        COLORS.white,

    fontSize:
        7,

    fontWeight:
        "bold"

}}
>

#

</Text>





<Text
style={{

    width:
        "12%",

    color:
        COLORS.white,

    fontSize:
        7,

    fontWeight:
        "bold"

}}
>

Date

</Text>





<Text
style={{

    width:
        "14%",

    color:
        COLORS.white,

    fontSize:
        7,

    fontWeight:
        "bold"

}}
>

Category

</Text>






<Text
style={{

    width:
        "23%",

    color:
        COLORS.white,

    fontSize:
        7,

    fontWeight:
        "bold"

}}
>

Description

</Text>






<Text
style={{

    width:
        "12%",

    color:
        COLORS.white,

    fontSize:
        7,

    fontWeight:
        "bold",

    textAlign:
        "right"

}}
>

Paid

</Text>







<Text
style={{

    width:
        "14%",

    color:
        COLORS.white,

    fontSize:
        7,

    fontWeight:
        "bold",

    textAlign:
        "right"

}}
>

Balance

</Text>

</View>










{/* ====================================================
    TABLE ROWS
==================================================== */}



{

transactions.map(

    (

        item,

        index

    ) => (


<View

key={
    index
}

wrap={false}

style={{

    flexDirection:
        "row",

    borderBottomWidth:
        1,

    borderBottomColor:
        COLORS.border,

    paddingVertical:
        3,

    paddingHorizontal:
        4

}}

>


<Text

style={{

width:
"5%",

fontSize:
7

}}

>

{
index + 1
}

</Text>






<Text

style={{

width:
"12%",

fontSize:
7

}}

>

{
formatDate(
item.date
)
}

</Text>







<Text

style={{

width:
"14%",

fontSize:
7

}}

>

{
item.payment_category ||
"-"
}

</Text>







<Text

style={{

width:
"23%",

fontSize:
7

}}

>

{
item.fee_type ||
"-"
}

</Text>








<Text

style={{

width:
"12%",

fontSize:
7,

textAlign:
"right"

}}

>

$

{
formatMoney(
item.amount_paid
)
}

</Text>









<Text

style={{

width:
"14%",

fontSize:
7,

textAlign:
"right"

}}

>

$

{
formatMoney(
item.balance
)
}

</Text>









<Text

style={{

width:
"20%",

fontSize:
7

}}

>

{
item.created_by ||
"-"
}

</Text>






</View>


)

)

}










{/* ====================================================
    FINANCIAL SUMMARY
==================================================== */}



<View

wrap={false}

style={{

marginTop:
10,

borderTopWidth:
1,

borderTopColor:
COLORS.blue,

paddingTop:
8

}}

>


<Text

style={{

fontSize:
11,

fontWeight:
"bold",

color:
COLORS.blue,

marginBottom:
6

}}

>

Final Account Summary

</Text>




<View

style={{

flexDirection:
"row",

justifyContent:
"space-between"

}}

>


<Text>

Total Amount Paid

</Text>


<Text

style={{

fontWeight:
"bold",

color:
COLORS.green

}}

>

$

{
formatMoney(
totalPaid
)
}

</Text>



</View>





<View

style={{

flexDirection:
"row",

justifyContent:
"space-between",

marginTop:
4

}}

>


<Text>

Outstanding Balance

</Text>


<Text

style={{

fontWeight:
"bold",

color:
COLORS.red

}}

>

$

{
formatMoney(
totalBalance
)
}

</Text>



</View>




</View>










{/* ====================================================
    VERIFICATION STATEMENT
==================================================== */}



<View

wrap={false}

style={{

marginTop:
10,

borderWidth:
1,

borderColor:
COLORS.border,

padding:
8

}}

>



<Text

style={{

fontSize:
10,

fontWeight:
"bold",

color:
COLORS.blue,

marginBottom:
4

}}

>

Verification Statement

</Text>





<Text

style={{

fontSize:
8,

lineHeight:
12,

color:
COLORS.text

}}

>



</Text>



</View>









{/* ====================================================
    SIGNATURE SECTION
==================================================== */}



<View

wrap={false}

style={{

flexDirection:
"row",

justifyContent:
"space-between",

marginTop:
18

}}

>




<View

style={{

width:
"35%",

borderTopWidth:
1,

borderTopColor:
COLORS.text,

paddingTop:
4

}}

>


<Text

style={{

fontSize:
8

}}

>

Finance Officer

</Text>


</View>






<View

style={{

width:
"35%",

borderTopWidth:
1,

borderTopColor:
COLORS.text,

paddingTop:
4

}}

>


<Text

style={{

fontSize:
8

}}

>

Authorized Approval

</Text>


</View>



</View>









{/* ====================================================
    FOOTER
==================================================== */}



<View

fixed

style={{

position:
"absolute",

bottom:
12,

left:
25,

right:
25,

borderTopWidth:
1,

borderTopColor:
COLORS.border,

paddingTop:
5,

flexDirection:
"row",

justifyContent:
"space-between"

}}

>



<Text

style={{

fontSize:
7,

color:
COLORS.gray

}}

>

SICSS | Student Finance Department - Polu Integrated School Management

</Text>





<Text

style={{

fontSize:
7,

color:
COLORS.gray

}}

>

Official Payment Statement

</Text>



</View>





</Page>


</Document>


);

};



export default StudentPaymentHistoryPDF;